/**
 * Represents the status of a pharmacy ID review.
 */
export enum PharmacyIdReviewStatusModel {
	/**
	 * The review is in progress.
	 */
	InProgress = 1,
	/**
	 * The review has been completed.
	 */
	Completed = 2,
	/**
	 * The review has been completed but action has been deferred
	 */
	Deferred = 3
}
